import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import EmployeeImportDataValidationFile from "../model/EmployeeImportDataValidationFile";

const DownloadEmployeeImportJobValidationFileApiService = async (
  request: number
): Promise<EmployeeImportDataValidationFile> => {
  const uri = `/employeeimportjob/${request}/download-import-validation-file/`;
  const { data } = await axios.post(uri);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useDownloadEmployeeImportJobValidationFileApiService = () =>
  useMutation<EmployeeImportDataValidationFile, AxiosError, number>(
    "DownloadEmployeeImportJobValidationFileApiService",
    DownloadEmployeeImportJobValidationFileApiService
  );

export default useDownloadEmployeeImportJobValidationFileApiService;
